import { trustItems, testimonials } from "@/mocks/homeData";
import { useState } from "react";

export default function TrustSection() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
        {/* Trust bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-16 md:mb-20">
          {trustItems.map((item) => (
            <div
              key={item.text}
              className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 border border-background-200/60"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                <i className={`${item.icon} text-accent-500 text-lg`} />
              </div>
              <span className="text-sm font-medium text-foreground-700">
                {item.text}
              </span>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">
            Opinie
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            Co mówią klienci
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative bg-white rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="absolute -top-4 left-8 md:left-10">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500">
                <i className="ri-double-quotes-l text-white text-lg" />
              </div>
            </div>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6 pt-4">
              {testimonials[activeTestimonial].text}
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-user-line text-primary-500" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">
                  {testimonials[activeTestimonial].name}
                </p>
                <p className="text-xs text-foreground-500">
                  {testimonials[activeTestimonial].location}
                </p>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveTestimonial(i)}
                className={`w-2.5 h-2.5 rounded-full transition-colors cursor-pointer ${
                  i === activeTestimonial ? "bg-accent-500" : "bg-background-300"
                }`}
                aria-label={`Opinia ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
